module.exports = __webpack_public_path__ + "img/MZ.ff276cd0.svg";